'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _weakMap = require('babel-runtime/core-js/weak-map');

var _weakMap2 = _interopRequireDefault(_weakMap);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

exports.default = createMemoizeMiddleware;
exports.memoize = memoize;

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACTION_TYPE = '@redux-memoize/action';

var DEFAULT_META = {
  ttl: 0,
  enabled: true,
  isEqual: _isEqual2.default
};

function isPromise(v) {
  return v && typeof v.then === 'function';
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function deepGet(map, args, isEqual) {
  var keys = (0, _from2.default)(map.keys());
  for (var i = 0, len = keys.length; i < len; i += 1) {
    var key = keys[i];
    if (isEqual(key, args)) {
      return map.get(key);
    }
  }
  return null;
}

function createMemoizeMiddleware() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (canUseDOM && options.ttl === undefined) {
    throw new Error('[createMemoizeMiddleware(globalOptions)] globalOptions.ttl is REQUIRED');
  }
  var _options$disableTTL = options.disableTTL,
      disableTTL = _options$disableTTL === undefined ? !canUseDOM : _options$disableTTL,
      globalOptions = (0, _objectWithoutProperties3.default)(options, ['disableTTL']);


  var cache = options.cache || new _weakMap2.default();
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if ((typeof action === 'undefined' ? 'undefined' : (0, _typeof3.default)(action)) === 'object' && action.type === ACTION_TYPE) {
          var _action$payload = action.payload,
              fn = _action$payload.fn,
              args = _action$payload.args;

          var _DEFAULT_META$globalO = (0, _extends3.default)({}, DEFAULT_META, globalOptions, action.meta || {}),
              ttl = _DEFAULT_META$globalO.ttl,
              enabled = _DEFAULT_META$globalO.enabled,
              isEqual = _DEFAULT_META$globalO.isEqual;

          var taskCache = cache.get(fn);
          if (!taskCache) {
            taskCache = new _map2.default();
            cache.set(fn, taskCache);
          }

          if (typeof enabled === 'function' ? enabled(getState) : enabled) {
            var task = deepGet(taskCache, args, isEqual);
            if (!task) {
              var _result = dispatch(fn.apply(undefined, (0, _toConsumableArray3.default)(args)));
              task = isPromise(_result) ? _result : _promise2.default.resolve(_result);
              var finalTTL = typeof ttl === 'function' ? ttl(getState) : ttl;
              if (finalTTL) {
                taskCache.set(args, task);
                if (!disableTTL) {
                  setTimeout(function () {
                    taskCache.delete(args);
                  }, finalTTL);
                }
              }
            }
            return task;
          }
          var result = dispatch(fn.apply(undefined, (0, _toConsumableArray3.default)(args)));
          return isPromise(result) ? result : _promise2.default.resolve(result);
        }
        return next(action);
      };
    };
  };
  return middleware;
}

function memoize(opts, fn) {
  var func = void 0;
  var options = void 0;
  if (arguments.length < 2) {
    options = null;
    func = opts;
  } else {
    options = (typeof opts === 'undefined' ? 'undefined' : (0, _typeof3.default)(opts)) === 'object' ? opts : { ttl: opts };
    func = fn;
  }
  if (typeof func !== 'function') {
    throw new Error('Not a function');
  }
  var memoized = function memoized() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var action = {
      type: ACTION_TYPE,
      payload: {
        fn: func,
        args: args
      }
    };
    if (options) {
      action.meta = options;
    }
    return action;
  };
  memoized.unmemoized = func;
  return memoized;
}